import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';

import ChangePlanPage from '../../../components/ChangePlan/default';
import { requestAsync, resetProductExchange } from '../../../queries/actions';
import { updatePlanSubscription } from '../../../queries/subscription';
import { selectActivePlanSubscription, selectAvailablePlansToChange, selectProducts } from '../../../queries/selectors/products';
import { selectSubscriberConfig, selectSubscriptionList } from '../../../queries/selectors/bootstrap';
import { selectCurrentContentFichaPath } from '../../../queries/selectors/contents';
import { selectUserData } from '../../../queries/selectors/user';
import withMembershipGuard from '../../withMembershipGuard';
import withMembershipPurchased from '../../withMembershipPurchased';

import withAuthGuard from '../../withAuthGuard';
import withPaymentStatus from '../../withPaymentStatus';
import withNoAvailableProducts from '../../withNoAvailableProducts';
import { selectClient } from '../../../global-selectors';
import { selectCurrentPaymentMethod } from '../../../queries/selectors/payment';
import { addProduct, cleanOrder } from '../../../queries/actions/shoppingCart';
import { setIgnoreRedirectInSubscription } from '../../../queries/actions/subscriber';
import { applyProductRules } from '../../../queries/actions/rules';

const mapStateToProps = state => ({
  userPlan: selectActivePlanSubscription(state),
  plans: selectAvailablePlansToChange(state),
  products: selectProducts(state),
  path: selectCurrentContentFichaPath(state),
  subscriptions: selectSubscriptionList(state),
  methodId: selectCurrentPaymentMethod(state),
  user: selectUserData(state),
  client: selectClient(state),
  subscriber: selectSubscriberConfig(state),
});

const mapDispatchToProps = (
  (dispatch) => bindActionCreators({
    addProduct: (data) => addProduct(data),
    updatePlanSubscription: (data) => requestAsync(updatePlanSubscription, data),
    setIgnoreRedirect: payload => setIgnoreRedirectInSubscription(payload),
    cleanOrder: () => cleanOrder(),
    resetProductExchange: () => resetProductExchange(),
    applyProductRules: (data) => dispatch(applyProductRules(data)),
  }, dispatch)
);

export default compose(
  injectIntl,
  withMembershipGuard,
  withPaymentStatus,
  withMembershipPurchased,
  connect(mapStateToProps, mapDispatchToProps),
  withAuthGuard({ toLoginURL: true }),
  withNoAvailableProducts('plan')
)(ChangePlanPage);
